import { ModelRegistry } from './model-registry';

export function Model(modelName : string) {
    return (target : Function) => {
        ModelRegistry.registerModel(target, modelName);
    }
}